import React from 'react'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

import front from "../images/fron.jpg";
import FoodBeverage from "../images/Food Beverage.jpg";
import foodservice from "../images/Food Service.jpg";
import Restaurant from "../images/Restaurant.jpg";

import equipment from "../images/equipment.jpg";
import parkking from "../images/parking.jpg";
import clasroom from "../images/class room 2.jpg";
import Entrance from "../images/Entrance.jpg";

import roomservice from "../images/Room Service.jpg";



function HotelPhoto() {
    return (
        <div>
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={front} className="card-img-top" alt="front"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Front Build </h5>



                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={FoodBeverage} className="card-img-top" alt="FoodBeverage"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Food Beverage </h5>


                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={foodservice} className="card-img-top" alt="foodservice"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Food Service </h5>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={Restaurant} className="card-img-top" alt="Restaurant"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" > Restaurant                           </h5>


                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={equipment} className="card-img-top" alt="equipment"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Equipment</h5>



                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={parkking} className="card-img-top" alt="parkking"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Parkking </h5>


                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={clasroom} className="card-img-top" alt="clasroom"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Class Room </h5>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={Entrance} className="card-img-top" alt="Entrance"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Entrance                               </h5>


                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            
<div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={roomservice} className="card-img-top" alt="roomservice"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Room Service</h5>



                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                                </div>
                                </div>
                                </div>
                                </div>
        </div>
    )
}

export default HotelPhoto